/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import {
  Form,
  Divider,
  PhoneInput,
  DateInput,
  Tooltip,
} from '@mairistem/composants';
import type { ParametresGeneraux } from '@/types';

import TabParametre from '../TabParametre';

interface TabRecensementProps {
  parametres: ParametresGeneraux;
  errors?: any;
  onChange: (
    e: React.SyntheticEvent,
    data: { name: string; value: string },
  ) => void;
}

const TabRecensement = (props: TabRecensementProps) => {
  const { parametres, errors = {}, onChange } = props;

  const {
    prepose,
    versionFichierPecoto,
    numeroFichierPecoto,
    dernierEnvoiPecoto,
  } = parametres || {};

  const { nom, prenom, qualite, telephone, email } = prepose || {};

  const handleChangeTelephone = React.useCallback(
    (value) => {
      onChange(null, { name: 'prepose.telephone', value });
    },
    [onChange],
  );

  const handleEmailChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;

      const invalidPatterns = /@.*@|\.\.|\s/;

      if (invalidPatterns.test(value)) {
        return;
      }

      onChange(e, { name, value });
    },
    [onChange],
  );

  return (
    <TabParametre title="GESTION DU RECENSEMENT">
      <Form.Group>
        <Tooltip
          trigger={
            <Form.Input
              width={5}
              name="prepose.prenom"
              label="Prénom du responsable"
              required
              value={_.upperFirst(prenom)}
              onChange={onChange}
            />
          }
          type={errors.prenomPrepose ? 'error' : ''}
          message={errors.prenomPrepose}
        />
        <Tooltip
          trigger={
            <Form.Input
              width={5}
              name="prepose.nom"
              label="Nom du responsable"
              required
              value={_.toUpper(nom)}
              onChange={onChange}
            />
          }
          type={errors.nomPrepose ? 'error' : ''}
          message={errors.nomPrepose}
        />
        <Form.Input
          width={6}
          name="prepose.qualite"
          label="Qualité"
          value={qualite}
          onChange={onChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Field width={5} required>
          <label>Téléphone</label>
          <Tooltip
            trigger={
              <PhoneInput
                data-testid="telephone-prepose-recensement-tab"
                value={telephone}
                onChange={(value) => handleChangeTelephone(value)}
              />
            }
            type={errors.telephonePrepose ? 'error' : ''}
            message={errors.telephonePrepose}
          />
        </Form.Field>
        <Tooltip
          trigger={
            <Form.Input
              width={11}
              name="prepose.email"
              label="Courriel"
              required
              data-testid="email-prepose-recensement-tab"
              icon="mail"
              value={email}
              onChange={handleEmailChange}
            />
          }
          type={errors.emailPrepose ? 'error' : ''}
          message={errors.emailPrepose}
        />
      </Form.Group>
      <Divider horizontal>PECOTO+</Divider>
      <Form.Group>
        <Form.Field>
          <label>Dernier envoi le</label>
          <DateInput
            readOnly
            data-testid="dernier-envoi-pecoto-tab"
            value={dernierEnvoiPecoto ? new Date(dernierEnvoiPecoto) : null}
          />
        </Form.Field>
        <Form.Field width={1} />
        <Form.Input
          width={2}
          disabled
          name="dernierNFichier"
          label="N° Fichier"
          input={{ 'data-testid': 'numero-fichier-pecoto-tab' }}
          value={numeroFichierPecoto}
          onChange={onChange}
        />
        <Form.Field width={1} />
        <Form.Input
          width={2}
          disabled
          name="dernierNVersion"
          input={{ 'data-testid': 'version-fichier-pecoto-tab' }}
          label="Version"
          value={versionFichierPecoto}
          onChange={onChange}
        />
      </Form.Group>
    </TabParametre>
  );
};

export default TabRecensement;
